import { Injectable, inject } from '@angular/core';

import { HttpClientPort } from '../../core/http/http-client.port';
import { Language } from '../../domain/entities/language';
import { Population } from '../../domain/entities/population';
import { PopulationRepository } from '../../domain/repositories/population.repository';
import { toApiLanguage } from '../http/api-language';
import { BOLDEST_ENDPOINTS } from '../http/boldest-endpoints';
import { toPopulation } from '../mappers/population.mapper';
import { unwrapCollection } from '../mappers/raw-json';

@Injectable()
export class HttpPopulationRepository extends PopulationRepository {
  private readonly http = inject(HttpClientPort);

  async findAll(language: Language): Promise<readonly Population[]> {
    const payload = await this.http.get({
      path: BOLDEST_ENDPOINTS.populations,
      query: { lang: toApiLanguage(language) },
    });

    return unwrapCollection(payload, 'populations')
      .map(toPopulation)
      .filter((population): population is Population => population !== null);
  }
}
